import { render, staticRenderFns } from "./PassForm.vue?vue&type=template&id=4e0a361b"
import script from "./PassForm.vue?vue&type=script&lang=js"
export * from "./PassForm.vue?vue&type=script&lang=js"
import style0 from "./PassForm.vue?vue&type=style&index=0&id=4e0a361b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports